module.exports = __webpack_public_path__ + "static/DEV3-ab9d79a1cc6b14569155725ff45f13ce.jpg";